import { useCallback, useEffect } from 'react';
import { useConfig } from 'core/common/hooks';
import { PaymentError, PaymentErrorCode } from '../entities';

type PaymentMessage = {
  type: 'success' | 'fail';
  code: PaymentErrorCode;
  message: string;
};

type Params = {
  paymentFailed: (error: PaymentError) => void;
  paymentSucceed: () => void;
};

export const useThreeDomainSecurePaymentListener = ({ paymentSucceed, paymentFailed }: Params) => {
  const { paymentTrustedOrigin } = useConfig();

  const paymentListener = useCallback(
    (event: MessageEvent) => {
      if (event.origin !== paymentTrustedOrigin) {
        return;
      }

      const { type, code, message } = event.data as PaymentMessage;

      if (type === 'fail') {
        paymentFailed({ code, message });
        return;
      }

      if (type === 'success') {
        paymentSucceed();
        return;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paymentFailed, paymentSucceed],
  );

  useEffect(() => {
    window.addEventListener('message', paymentListener);

    return () => {
      window.removeEventListener('message', paymentListener);
    };
  }, [paymentListener]);
};
